import "core-js/modules/es.array.push.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "gifts-page page"
  }, [_c('m-head'), _c('div', {
    staticClass: "gifts-main page-main"
  }, [_c('div', {
    staticClass: "gifts-title"
  }, [_c('span', [_vm._v("GIFTS")]), _c('div', {
    staticClass: "gifts-title-btns"
  }, [_c('div', {
    staticClass: "btn-mygift",
    on: {
      "click": _vm.onOpenMarket
    }
  }, [_c('svg-icon', {
    staticClass: "getgems",
    attrs: {
      "name": "icon-getgems"
    }
  }), _c('div', [_vm._v("Market Price")])], 1), _c('div', {
    staticClass: "btn-mygift",
    on: {
      "click": _vm.onShowMyGift
    }
  }, [_vm._v("My Gift "), _c('svg-icon', {
    attrs: {
      "name": "icon-arrow"
    }
  })], 1)])]), _c('div', {
    staticClass: "gifts-sub"
  }, [_c('svg-icon', {
    attrs: {
      "name": "icon-tip"
    }
  }), _vm._v(" "), _c('i', [_vm._v("Collect all the Shards to get high-value GIFT for free")])], 1), _vm.giftList ? [_vm.giftList.length > 0 ? [_c('transition-group', {
    staticClass: "gifts-list",
    attrs: {
      "appear": "",
      "tag": "div"
    },
    on: {
      "before-enter": _vm.beforeEnter,
      "enter": _vm.enterShowDaily
    }
  }, [_vm.giftList && _vm.giftList.length > 0 ? _vm._l(_vm.giftList, function (item, index) {
    return _c('div', {
      key: `gifts${index}`,
      staticClass: "gifts-item",
      attrs: {
        "data-index": index <= 50 ? index + 0.2 : 0
      },
      on: {
        "click": function ($event) {
          return _vm.onShowGiftDetail(item, index);
        }
      }
    }, [_c('div', {
      staticClass: "gifts-item-body"
    }, [_c('div', {
      staticClass: "gifts-item-main"
    }, [_c('div', {
      staticClass: "gifts-item-chip"
    }, [_c('div', {
      staticClass: "gifts-item-chip-main",
      style: {
        background: `url(${item.gift_image}) center top/auto 100% no-repeat`
      }
    })]), _c('div', {
      staticClass: "gifts-item-progress"
    }, [_c('div', {
      staticClass: "gifts-item-progress-main"
    }, [_c('div', {
      staticClass: "gifts-item-progress-bar"
    }, [_c('div', {
      staticClass: "bar",
      style: {
        transform: `translateX(-${(1 - item.shard_amount / item.required_shards) * 100}%)`
      }
    })])]), _c('div', {
      staticClass: "gifts-item-progress-text"
    }, [_vm._v(_vm._s(_vm.fmt_pre(item.shard_amount)) + "/" + _vm._s(_vm.fmt_pre(item.required_shards)))])]), _c('div', {
      staticClass: "gift-item__name"
    }, _vm._l(Array.from({
      length: item.gift_level
    }, (_, i) => i + 1), function (_) {
      return _c('img', {
        attrs: {
          "src": require('@images/icon/icon-star2.png'),
          "alt": ""
        }
      });
    }), 0)])])]);
  }) : _vm._e()], 2)] : _vm._e()] : _c('div', {
    staticClass: "gifts-loading"
  }, [_c('div', {
    staticClass: "circleLoading"
  })])], 2), _c('div', {
    staticClass: "gifts-btns wow fadeInUpBig",
    attrs: {
      "data-wow-duration": "0.5s"
    }
  }, [_c('div', {
    staticClass: "gifts-btns-main"
  }, [_c('div', {
    staticClass: "gifts-btns__title"
  }, [_vm._v("How to get Shards?")]), _c('div', {
    staticClass: "gifts-btns-list"
  }, _vm._l(_vm.menuBtns, function (val, key, index) {
    return _c('div', {
      key: index,
      staticClass: "gifts-btns-item wow fadeInUpBig",
      class: key,
      attrs: {
        "data-wow-duration": `${0.5 + index * 0.1}s`
      },
      on: {
        "click": () => _vm.$router.push(val.page)
      }
    }, [_c('span', [_vm._v(_vm._s(val.title))]), _c('i', {
      domProps: {
        "innerHTML": _vm._s(val.reward)
      }
    })]);
  }), 0)])]), _c('pop-prompt', {
    attrs: {
      "isShadowClick": true,
      "show": _vm.popGiftDetailShow,
      "content": "html",
      "title": "",
      "isBtnCancel": false,
      "isBtnConfirm": false
    },
    on: {
      "update:show": function ($event) {
        _vm.popGiftDetailShow = $event;
      }
    }
  }, [_vm.rowGift ? _c('div', {
    staticClass: "pop-giftdetail"
  }, [_c('div', {
    staticClass: "pop-giftdetail__desc"
  }, [_vm._v("Collect all the Shards to"), _c('br'), _vm._v(" get high-value GIFT for free")]), _c('div', {
    staticClass: "pop-giftdetail__icon",
    style: {
      background: `url(${_vm.rowGift.gift_thumb}) center/auto 100% no-repeat`
    }
  }), _c('div', {
    staticClass: "pop-giftdetail__title"
  }, [_vm._v(_vm._s(_vm.rowGift.gift_name))]), _c('div', {
    staticClass: "pop-giftdetail__market"
  }, [_c('div', {
    staticClass: "btn-market",
    on: {
      "click": _vm.onOpenMarket
    }
  }, [_c('svg-icon', {
    staticClass: "getgems",
    attrs: {
      "name": "icon-getgems"
    }
  }), _c('div', {
    staticClass: "btn-market__title"
  }, [_vm._v("Market Price "), _c('span', _vm._l(Array.from({
    length: _vm.rowGift.gift_level
  }, (_, i) => i + 1), function (_) {
    return _c('img', {
      attrs: {
        "src": require('@images/icon/icon-star2.png'),
        "alt": ""
      }
    });
  }), 0)])], 1)]), _vm.rowGift.progress ? _c('div', {
    staticClass: "pop-giftdetail-main"
  }, _vm._l(_vm.rowGift.progress, function (item, index) {
    return _c('div', {
      key: index,
      staticClass: "pop-giftdetail-items"
    }, [_c('div', {
      staticClass: "pop-giftdetail-pro"
    }, [_c('div', {
      staticClass: "pop-giftdetail-ship",
      style: {
        background: `url(${_vm.rowGift.gift_image}) center/auto 100% no-repeat`
      }
    }), _c('div', {
      staticClass: "gifts-item-progress"
    }, [_c('div', {
      staticClass: "gifts-item-progress-main"
    }, [_c('div', {
      staticClass: "gifts-item-progress-bar"
    }, [_c('div', {
      staticClass: "bar",
      style: {
        transform: `translateX(-${(1 - item / _vm.rowGift.required_shards) * 100}%)`
      }
    })])]), _c('div', {
      staticClass: "gifts-item-progress-text"
    }, [_vm._v(_vm._s(item) + "/" + _vm._s(_vm.rowGift.required_shards))])]), index == 0 && _vm.rowGift.time > 1 ? _c('div', {
      staticClass: "pop-giftdetail-tag"
    }, [_vm._v("x" + _vm._s(_vm.rowGift.time))]) : _vm._e()]), item >= _vm.rowGift.required_shards ? _c('div', {
      staticClass: "pop-giftdetail-btns ok"
    }, [_c('div', {
      staticClass: "btn btn-get",
      class: _vm.giftList[_vm.rowGift.index].isSellLoading && 'disable',
      on: {
        "click": function ($event) {
          return _vm.onShowGiftSell(item, 0);
        }
      }
    }, [item < _vm.rowGift.required_shards || !_vm.giftList[_vm.rowGift.index].isGetLoading ? [_vm._v(" Get")] : [_c('div', {
      staticClass: "circleLoading"
    })]], 2), _c('div', {
      staticClass: "btn btn-sell",
      class: _vm.giftList[_vm.rowGift.index].isGetLoading && 'disable',
      on: {
        "click": function ($event) {
          return _vm.onShowGiftSell(item, 1);
        }
      }
    }, [!_vm.giftList[_vm.rowGift.index].isSellLoading ? [_vm._v(" Sell  "), item >= _vm.rowGift.required_shards ? [_c('img', {
      attrs: {
        "src": require('@images/icon/icon-star.png'),
        "alt": ""
      }
    }), _vm._v(_vm._s(_vm.fmt_pre(_vm.rowGift.recycling_stars)))] : _vm._e()] : [_c('div', {
      staticClass: "circleLoading"
    })]], 2)]) : _vm._e()]);
  }), 0) : _vm._e()]) : _vm._e()]), _c('pop-prompt', {
    attrs: {
      "isShadowClick": !_vm.rowGiftSellContent || _vm.rowGiftSellContent.type != 'get2' || _vm.isPopGiftSellClose,
      "isClose": !_vm.rowGiftSellContent || _vm.rowGiftSellContent.type != 'get2' || _vm.isPopGiftSellClose,
      "show": _vm.popGiftSellShow,
      "content": "html",
      "title": "",
      "isBtnCancel": false,
      "isBtnConfirm": false
    },
    on: {
      "update:show": function ($event) {
        _vm.popGiftSellShow = $event;
      }
    }
  }, [_vm.rowGiftSellContent ? _c('div', {
    staticClass: "pop-giftSell"
  }, [_c('div', {
    staticClass: "pop-giftSell__title",
    domProps: {
      "innerHTML": _vm._s(_vm.rowGiftSellContent.title)
    }
  }), _c('div', {
    staticClass: "pop-giftSell__sub",
    domProps: {
      "innerHTML": _vm._s(_vm.rowGiftSellContent.content)
    }
  }), _c('div', {
    staticClass: "pop-giftSell-btns"
  }, [_vm.giftList[this.rowGift.index].isSellLoading || _vm.giftList[this.rowGift.index].isGetLoading ? _c('div', {
    staticClass: "btn"
  }, [_c('div', {
    staticClass: "circleLoading"
  })]) : _c('div', {
    staticClass: "btn",
    class: _vm.rowGiftSellContent.type,
    domProps: {
      "innerHTML": _vm._s(_vm.rowGiftSellContent.btn)
    },
    on: {
      "click": function ($event) {
        return _vm.rowGiftSellContent.btnSkip(_vm.rowGiftSellContent.type);
      }
    }
  })])]) : _vm._e()]), _c('pop-prompt', {
    attrs: {
      "isShadowClick": true,
      "className": "popMyGiftClass",
      "show": _vm.popMyGiftShow,
      "content": "html",
      "isBtnCancel": false,
      "isBtnConfirm": false,
      "title": "My Gifts"
    },
    on: {
      "update:show": function ($event) {
        _vm.popMyGiftShow = $event;
      }
    }
  }, [_c('div', {
    staticClass: "pop-mygift"
  }, [_c('div', {
    ref: "popmygift",
    staticClass: "pop-mygift-main"
  }, [_vm.myGiftList ? [_vm.myGiftList.length > 0 ? [_c('transition-group', {
    staticClass: "pop-mygift-list",
    attrs: {
      "appear": "",
      "tag": "div"
    },
    on: {
      "before-enter": _vm.beforeEnter,
      "enter": _vm.enterLongList
    }
  }, _vm._l(_vm.myGiftList, function (item, index) {
    return _c('div', {
      key: `mygift${index}`,
      staticClass: "pop-mygift-item",
      attrs: {
        "data-index": index <= 50 ? index + 0.1 : 0
      }
    }, [_c('div', {
      staticClass: "pop-mygift-item-chip",
      style: {
        background: `url(${item.gift_thumb}) center/auto 100% no-repeat`
      }
    }), _c('div', {
      staticClass: "pop-mygift-item-info"
    }, [item.gift_name ? _c('div', {
      staticClass: "pop-mygift-item__name"
    }, [_vm._v(_vm._s(item.gift_name))]) : _vm._e(), item.gift_status == 0 ? _c('div', {
      staticClass: "pop-mygift-item__tip"
    }, [!item.gift_type ? [_vm._v("Will be distributed within 24 hours, please make sure tointeract with "), _c('em', {
      on: {
        "click": function ($event) {
          return _vm.onSkip(_vm.settingInfo.botname);
        }
      }
    }, [_vm._v("@" + _vm._s(_vm.settingInfo.botname))])] : [_vm._v("Will be distributed within 24 hours, please make sure tointeract with "), _c('em', {
      on: {
        "click": function ($event) {
          _vm.onSkip(_vm.adminName.charAt(0).toLowerCase() + _vm.adminName.slice(1));
        }
      }
    }, [_vm._v("@" + _vm._s(_vm.adminName))])]], 2) : _vm._e()]), _c('div', {
      staticClass: "pop-mygift-item-num"
    }, [item.gift_status == 2 ? _c('span', {
      staticStyle: {
        "color": "#a0fe07"
      }
    }, [_c('svg-icon', {
      attrs: {
        "name": "icon-ok"
      }
    }), _vm._v("Sold")], 1) : item.gift_status == 0 ? _c('span', {
      staticStyle: {
        "color": "#ffc600"
      }
    }, [_c('svg-icon', {
      attrs: {
        "name": "icon-time"
      }
    }), _vm._v(" Issuing")], 1) : item.gift_status == 1 ? _c('span', {
      staticStyle: {
        "color": "#a0fe07"
      }
    }, [_c('svg-icon', {
      attrs: {
        "name": "icon-ok"
      }
    }), _vm._v("Issued")], 1) : _vm._e(), item.gift_status == 2 ? _c('div', {
      staticClass: "pop-mygift-item__price"
    }, [_c('img', {
      attrs: {
        "src": require('@images/icon/icon-star.png'),
        "alt": ""
      }
    }), _vm._v("20")]) : _vm._e()])]);
  }), 0)] : _c('div', {
    staticClass: "pop-mygift-empty"
  }, [_vm._v("There's nothing here!")])] : [_c('div', {
    staticClass: "circleLoading"
  })]], 2)])]), _c('m-menu')], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };